import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { ContainerComponent } from './components/container/container.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { AuthGuard } from './utils/auth.guard';
import { CatalogueComponent } from './components/catalogue/catalogue.component';
import { CatalogueImagesComponent } from './components/catalogue/catalogue-images/catalogue-images.component';
import { CatalogueExcelComponent } from './components/catalogue/catalogue-excel/catalogue-excel.component';
import { FormsComponent } from './components/catalogue/forms/forms.component';
import { UserDataComponent } from './components/catalogue/user-data/user-data.component';
import { CatalogueVideosComponent } from './components/catalogue/catalogue-videos/catalogue-videos.component';
import { SectionsComponent } from './components/catalogue/sections/sections.component';
import { PushNotificationComponent } from './components/push-notification/push-notification.component';
import { PushNotificationHistoryComponent } from '@notification/push-notification-history/push-notification-history.component';
import { ReportsComponent } from './components/reports/reports.component';
import { UserManagmentComponent } from './components/user-managment/user-managment.component';
import { IfaListComponent } from './components/ifa-list/ifa-list.component';
import { InvestorListComponent } from '@investor-list/investor-list.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    component: ContainerComponent,
    children: [
      {
        path: 'catalogue',
        component: CatalogueComponent,
        children: [
          {
            path: '',
            redirectTo: 'banner',
            pathMatch: 'full',
          },
          {
            path: 'banner',
            component: CatalogueImagesComponent,
          },
          {
            path: 'excel',
            component: CatalogueExcelComponent,
          },
          {
            path: 'forms',
            component: FormsComponent,
          },
          {
            path: 'user',
            component: UserDataComponent,
          },
          {
            path: 'videos',
            component: CatalogueVideosComponent,
          },
          {
            path: 'sections',
            component: SectionsComponent,
          },
        ],
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      },
      {
        path: 'push-notifications',
        component: PushNotificationComponent,
      },
      {
        path: 'reports',
        component: ReportsComponent,
      },
      {
        path: 'user-management',
        component: UserManagmentComponent,
      },
      {
        path: 'ifa-list',
        component: IfaListComponent,
      },
      {
        path: 'investor-list',
        component: InvestorListComponent
      },
    ],
  },
  {
    path: 'push-notifications-history',
    component: PushNotificationHistoryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
